import CheckmarkSvg from '../../../assets/checkmark.svg?react';
import { IconProps } from '../../types/IconProps';

export function Checkmark({ size = 20, ...props }: IconProps) {
  return <CheckmarkSvg data-testid="checkmark-icon" width={size} height={size} {...props} />;
}

export default Checkmark;
